const initialState = () => {
    return {
        /**
         * @description
         * Here you should declare the state properties and it's initial values
         */
        employee: {
            id: '',
            rut: '',
            names: '',
            last_name1: '',
            last_name2: '',
            discount: 0,
        },
        validEmployee: false,
    }
}

export default initialState
